import Page from './Page';
export default Page;
export { default as getData } from './getData';